import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import Typography from '@classify/react-core-components/Typography';
import { useIsOverflowed } from '../../../utils';
export default function MenuItemName(t0) {
  const $ = _c(8);
  const {
    name
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = [name];
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isOverflowed,
    setDomElement
  } = useIsOverflowed(t1);
  const t2 = isOverflowed ? name : "";
  let t3;
  if ($[2] !== name || $[3] !== setDomElement) {
    t3 = <Typography variant="body" noWrap={true} ref={setDomElement}>{name}</Typography>;
    $[2] = name;
    $[3] = setDomElement;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Tooltip title={t2} enterDelay={500}>{t3}</Tooltip>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}